// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
import { NavItemProps } from 'components/NavSection';
import { WORKSPACES_INGAFOOD, WORKSPACES_REPSOL } from 'guards/CheckRoles';
// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const getGirafIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/giraf/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  home: getIcon('ic_home'),
  share: getGirafIcon('share'),
  calculatedMeasure: getGirafIcon('calculated_measure'),
  asset: getGirafIcon('asset'),
  deviceGroup: getGirafIcon('device_group'),
  device: getGirafIcon('device'),
  alarm: getGirafIcon('alarm'),
  label: getGirafIcon('label'),
  truck: getGirafIcon('truck'),
  listCheckSolid: getGirafIcon('list-check-solid'),
  wheatLight: getGirafIcon('wheat-light'),
  jarWheatLight: getGirafIcon('jar-wheat-light'),
  buildingWheatLight: getGirafIcon('building-wheat-light'),
  warehouse: getGirafIcon('warehouse')
};

export type SidebarConfigType = {
  subheader: string;
  roles?: string[];
  modules?: string[];
  items: NavItemProps[];
}[];

const sidebarConfig: SidebarConfigType = [
  // GENERAL
  // ----------------------------------------------------------------------
  /* {
    subheader: 'general',
    items: [
      { title: 'One', path: PATH_DASHBOARD.general.pageOne, icon: ICONS.dashboard },
      { title: 'Two', path: PATH_DASHBOARD.general.pageTwo, icon: ICONS.ecommerce },
      { title: 'Three', path: PATH_DASHBOARD.general.pageThree, icon: ICONS.analytics }
    ]
  },*/

  // Data
  {
    subheader: 'data',
    roles: ['ROLE_USER', 'ROLE_END_USER'],
    modules: [],
    items: [
      {
        title: 'reports',
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.dashboard,
        children: [
          { title: 'view_all', path: PATH_DASHBOARD.reports.list, roles: [] } //,
          //{ title: 'add', path: PATH_DASHBOARD.reports.new }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'devices',
        path: PATH_DASHBOARD.devices.root,
        icon: ICONS.device,
        children: [
          { title: 'list', path: PATH_DASHBOARD.devices.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.devices.new, roles: ['ROLE_USER'] },
          { title: 'tags', path: PATH_DASHBOARD.devices.labels, roles: ['ROLE_USER'] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'devices',
        path: PATH_DASHBOARD.end_user.devices.root,
        icon: ICONS.device,
        children: [{ title: 'list', path: PATH_DASHBOARD.end_user.devices.list, roles: [] }],
        roles: ['ROLE_END_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'reports',
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.dashboard,
        children: [{ title: 'view_all', path: PATH_DASHBOARD.end_user.reports.list, roles: [] }],
        roles: ['ROLE_END_USER'],
        workspaces: WORKSPACES_REPSOL,
        modules: []
      },
      {
        title: 'calculated_data',
        path: PATH_DASHBOARD.calculatedData.root,
        icon: ICONS.calculatedMeasure,
        children: [
          { title: 'list', path: PATH_DASHBOARD.calculatedData.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.calculatedData.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },

      {
        title: 'assets',
        path: PATH_DASHBOARD.assets.root,
        icon: ICONS.asset,
        children: [
          { title: 'list', path: PATH_DASHBOARD.assets.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.assets.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'delivery_requests',
        path: PATH_DASHBOARD.delivery_request.root,
        icon: ICONS.listCheckSolid,
        children: [
          { title: 'list', path: PATH_DASHBOARD.delivery_request.list, roles: [] }
          // { title: 'add', path: PATH_DASHBOARD.assets.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: ['orders']
      }
    ]
  },
  {
    subheader: 'configuration',
    roles: ['ROLE_END_USER'],
    modules: [],
    items: [
      {
        title: 'alarms',
        path: PATH_DASHBOARD.alarms.root,
        icon: ICONS.alarm,
        children: [
          { title: 'list', path: PATH_DASHBOARD.end_user.alarms.list, roles: ['ROLE_END_USER'] }
        ],
        roles: ['ROLE_END_USER'],
        workspaces: '',
        modules: []
      }
    ]
  },
  // ----------------------------------------------------------------------
  {
    subheader: 'configuration',
    roles: ['ROLE_USER'],
    modules: [],
    items: [
      {
        title: 'alarms',
        path: PATH_DASHBOARD.alarms.root,
        icon: ICONS.alarm,
        children: [
          { title: 'list', path: PATH_DASHBOARD.alarms.list, roles: ['ROLE_USER'] },
          { title: 'add', path: PATH_DASHBOARD.alarms.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'device_groups:custom',
        path: PATH_DASHBOARD.deviceGroups.root,
        icon: ICONS.deviceGroup,
        children: [
          { title: 'list', path: PATH_DASHBOARD.deviceGroups.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.deviceGroups.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'buildings:custom',
        path: PATH_DASHBOARD.buildings.root,
        icon: ICONS.warehouse,
        children: [
          { title: 'list', path: PATH_DASHBOARD.buildings.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.buildings.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: WORKSPACES_INGAFOOD,
        modules: []
      },
      {
        title: 'naves',
        path: PATH_DASHBOARD.buildings.root,
        icon: ICONS.warehouse,
        children: [
          { title: 'list', path: PATH_DASHBOARD.buildings.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.buildings.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        only_workspaces: ['avia'],
        modules: []
      },
      {
        title: 'shared',
        path: PATH_DASHBOARD.shared.root,
        icon: ICONS.share,
        children: [
          { title: 'list', path: PATH_DASHBOARD.shared.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.shared.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: []
      },
      {
        title: 'delivery_configurations',
        path: PATH_DASHBOARD.deliveryConfigurations.root,
        icon: ICONS.truck,
        children: [
          { title: 'list', path: PATH_DASHBOARD.deliveryConfigurations.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.deliveryConfigurations.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        workspaces: '',
        modules: ['orders']
      },
      {
        title: 'product_types',
        path: PATH_DASHBOARD.productTypes.root,
        icon: ICONS.wheatLight,
        children: [
          { title: 'list', path: PATH_DASHBOARD.productTypes.list, roles: [] },
          { title: 'add', path: PATH_DASHBOARD.productTypes.new, roles: [] }
        ],
        roles: ['ROLE_USER'],
        // workspaces: '',
        // modules: ['product-type', 'product-schedule'],
        workspaces: WORKSPACES_INGAFOOD,
        modules: []
      },
      {
        title: 'schedule_templates',
        path: PATH_DASHBOARD.productScheduleTemplate.root,
        icon: ICONS.jarWheatLight,
        children: [
          { title: 'list', path: PATH_DASHBOARD.productScheduleTemplate.list },
          { title: 'add', path: PATH_DASHBOARD.productScheduleTemplate.new }
        ],
        roles: ['ROLE_USER'],
        // workspaces: '',
        // modules: ['product-schedule'],
        workspaces: WORKSPACES_INGAFOOD,
        modules: []
      },
      {
        title: 'schedules',
        path: PATH_DASHBOARD.productSchedule.root,
        icon: ICONS.buildingWheatLight,
        children: [
          { title: 'list', path: PATH_DASHBOARD.productSchedule.list },
          { title: 'add', path: PATH_DASHBOARD.productSchedule.new }
        ],
        roles: ['ROLE_USER'],
        // workspaces: '',
        // modules: ['product-schedule'],
        workspaces: WORKSPACES_INGAFOOD,
        modules: []
      }
    ]
  }
];

export default sidebarConfig;
